async function loadBrands() {
  const brandElements = document.querySelectorAll("[data-live-brand]:not([data-brand-checked])");
  if (!brandElements.length) return;

  const handles = [...brandElements].map(el => el.dataset.productHandle);

  const fetchBrandForHandle = async (handle) => {
    const query = `
      {
        productByHandle(handle: "${handle}") {
          handle
          vendor
          metafield(namespace: "custom", key: "product_brand") {
            reference {
              ... on Metaobject {
                fields {
                  key
                  value
                }
              }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch("/api/2023-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "790fbdc4d5d219cd4213960d6966d96a"
        },
        body: JSON.stringify({ query })
      });

      const result = await response.json();

      if (result.errors) {
        console.error(`GraphQL error for ${handle}:`, result.errors);
        throw new Error("GraphQL response error");
      }

      const product = result.data.productByHandle;
      const vendor = product?.vendor?.trim() || "Trundles";

      const fields = product?.metafield?.reference?.fields || [];
      const brandField = fields.find(f => f.key === "brand");
      const brand = brandField?.value?.trim();

      const el = document.querySelector(`[data-product-handle="${handle}"][data-live-brand]:not([data-brand-checked])`);
      if (el) {
        el.textContent = brand || vendor || "Brand not available";
        el.dataset.brandChecked = "true";
      }
    } catch (err) {
      console.error(`Error fetching brand for ${handle}:`, err);
      const el = document.querySelector(`[data-product-handle="${handle}"][data-live-brand]:not([data-brand-checked])`);
      if (el) {
        el.textContent = "Brand not available";
        el.dataset.brandChecked = "true";
      }
    }
  };

  await Promise.allSettled(handles.map(fetchBrandForHandle));
}

// ✅ Initial load
document.addEventListener("DOMContentLoaded", loadBrands);

// ✅ Watch for infinite scroll / dynamic inserts
const observer = new MutationObserver(() => {
  const unprocessed = document.querySelector('[data-live-brand]:not([data-brand-checked])');
  if (unprocessed) {
    loadBrands();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// ✅ Optional: Manually trigger loadBrands() if needed from other scripts
window.reloadLiveBrands = loadBrands;
